import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from '@mui/material';

interface FinalizeSelfAssessmentConfirmationProps {
    open: boolean;
    onClose: () => void;
    onFinalize: () => void;
}

const FinalizeSelfAssessmentConfirmation = (props: FinalizeSelfAssessmentConfirmationProps) => {
    return (
        <Dialog open={props.open} onClose={props.onClose}>
            <DialogTitle>
                Selbstauskunft einreichen
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Möchten Sie die Selbstauskunft wirklich einreichen? Die Daten können anschließend nicht mehr
                    bearbeitet werden.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={props.onClose}>
                    Abbrechen
                </Button>
                <Button color={'primary'} onClick={props.onFinalize} variant={'contained'}>
                    Einreichen
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default FinalizeSelfAssessmentConfirmation;
